import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { usePatient } from "@louise/patients/hooks/usePatient";
import { useCarePersons } from "@src/packages/patients/hooks/useCarePersons";
import { SexualHealthProvider, getResumeRoute } from "./SexualHealthContext";
import { PapSmearScreen } from "./screens/PapSmearScreen";
import { PapSmearProceduresScreen } from "./screens/PapSmearProceduresScreen";
import { PapSmearProcedureDetailsScreen } from "./screens/PapSmearProcedureDetailsScreen";
import { STDsScreen } from "./screens/STDsScreen";
import { STDDetailsScreen } from "./screens/STDDetailsScreen";
import { VaginalInfectionsScreen } from "./screens/VaginalInfectionsScreen";
import { VaginalInfectionDetailsScreen } from "./screens/VaginalInfectionDetailsScreen";
import { PainfulIntercourseScreen } from "./screens/PainfulIntercourseScreen";
import { LubricantsScreen } from "./screens/LubricantsScreen";
import { PartnerEjaculateScreen } from "./screens/PartnerEjaculateScreen";
import { ErectileDifficultiesScreen } from "./screens/ErectileDifficultiesScreen";
import { SexualHealthCompleteScreen } from "./screens/SexualHealthCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type SexualHealthStackParamList = {
  PapSmear: undefined;
  PapSmearProcedures: undefined;
  PapSmearProcedureDetails: undefined;
  STDs: undefined;
  STDDetails: undefined;
  VaginalInfections: undefined;
  VaginalInfectionDetails: undefined;
  PainfulIntercourse: undefined;
  Lubricants: undefined;
  PartnerEjaculate: undefined;
  ErectileDifficulties: undefined;
  SexualHealthComplete: undefined;
};

const Stack = createNativeStackNavigator<SexualHealthStackParamList>();

function SexualHealthStack() {
  const { data: patient } = usePatient();
  const { partnerPatient } = useCarePersons();
  const initialRoute = getResumeRoute(patient, partnerPatient);

  return (
    <Stack.Navigator
      initialRouteName={initialRoute}
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen name="PapSmear" component={PapSmearScreen} />
      <Stack.Screen
        name="PapSmearProcedures"
        component={PapSmearProceduresScreen}
      />
      <Stack.Screen
        name="PapSmearProcedureDetails"
        component={PapSmearProcedureDetailsScreen}
      />
      <Stack.Screen name="STDs" component={STDsScreen} />
      <Stack.Screen name="STDDetails" component={STDDetailsScreen} />
      <Stack.Screen
        name="VaginalInfections"
        component={VaginalInfectionsScreen}
      />
      <Stack.Screen
        name="VaginalInfectionDetails"
        component={VaginalInfectionDetailsScreen}
      />
      <Stack.Screen
        name="PainfulIntercourse"
        component={PainfulIntercourseScreen}
      />
      <Stack.Screen name="Lubricants" component={LubricantsScreen} />
      <Stack.Screen
        name="PartnerEjaculate"
        component={PartnerEjaculateScreen}
      />
      <Stack.Screen
        name="ErectileDifficulties"
        component={ErectileDifficultiesScreen}
      />
      <Stack.Screen
        name="SexualHealthComplete"
        component={SexualHealthCompleteScreen}
      />
    </Stack.Navigator>
  );
}

export function SexualHealthNavigator() {
  return (
    <SexualHealthProvider>
      <MedicalHistoryQuestionProvider
        section="sexual-health"
        sectionLabelKey="med_history.review.section_title.sexual-health"
        helpTextKey="med_history.question_screen.flow_help.sexual-health"
      >
        <SexualHealthStack />
      </MedicalHistoryQuestionProvider>
    </SexualHealthProvider>
  );
}
